import { getFullUrl } from 'hubspot-url-utils';
export const getRedirect = () => {
  try {
    return window.localStorage.getItem('SANDBOXES_REDIRECT') || 'sandboxes';
  } catch (error) {
    return 'sandboxes';
  }
};
export const getSetUpDeployLink = ({
  parentHubId,
  sandboxHubId
}) => {
  if (!parentHubId || !sandboxHubId) {
    return '';
  }
  return `${getFullUrl('app')}/${getRedirect()}/${parentHubId}/deploy-to-production?sandboxHubId=${sandboxHubId}`;
};